exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".training-knowledge-form-dialog__tips[data-v-e93b6aac]{color:#8492a6;font-size:12px;line-height:20px}", "", {"version":3,"sources":["/workspace/src/views/training/components/TrainingKnowledgeFormDialog.vue"],"names":[],"mappings":"AACA,uDAAuD,cAAc,eAAe,gBAAgB,CACnG","file":"TrainingKnowledgeFormDialog.vue","sourcesContent":["\n.training-knowledge-form-dialog__tips[data-v-e93b6aac]{color:#8492a6;font-size:12px;line-height:20px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e93b6aac","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/training/components/TrainingKnowledgeFormDialog.vue
// module id = 5623
// module chunks = 64